/* eslint max-len: 0 */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ACHIEVEMENTS = {
  // Fastest Time
  FT: {
    title: <FormattedMessage id='achievements.ft1' defaultMessage='Fastest Time' />,
    description: <FormattedMessage id='achivements.desc.ft1' defaultMessage='The fastest overall time on a course.' />,
  },

  // Guru
  guru: {
    title: <FormattedMessage id='achievements.guru' defaultMessage='Guru' />,
    description: <FormattedMessage id='achivements.desc.guru' defaultMessage='The athlete who has done the course the most times this year.' />,
  },

  // Personal Record
  pr1: {
    title: <FormattedMessage id='achievements.pr1' defaultMessage='Personal Record' />,
    description: <FormattedMessage id='achivements.desc.pr1' defaultMessage='Your best effort on this course.' />,
  },
  pr2: {
    title: <FormattedMessage id='achievements.pr2' defaultMessage='Personal Record 2' />,
    description: <FormattedMessage id='achivements.desc.pr2' defaultMessage='Your 2nd best effort on this course.' />,
  },
  pr3: {
    title: <FormattedMessage id='achievements.pr3' defaultMessage='Personal Record 3' />,
    description: <FormattedMessage id='achivements.desc.pr3' defaultMessage='Your 3rd best effort on this course.' />,
  },
  pr4: {
    title: <FormattedMessage id='achievements.pr4' defaultMessage='Personal Record 4' />,
    description: <FormattedMessage id='achivements.desc.pr4' defaultMessage='Your 4th best effort on this course.' />,
  },
  pr5: {
    title: <FormattedMessage id='achievements.pr5' defaultMessage='Personal Record 5' />,
    description: <FormattedMessage id='achivements.desc.pr5' defaultMessage='Your 5th best effort on this course.' />,
  },
  pr6: {
    title: <FormattedMessage id='achievements.pr6' defaultMessage='Personal Record 6' />,
    description: <FormattedMessage id='achivements.desc.pr6' defaultMessage='Your 6th best effort on this course.' />,
  },
  pr7: {
    title: <FormattedMessage id='achievements.pr7' defaultMessage='Personal Record 7' />,
    description: <FormattedMessage id='achivements.desc.pr7' defaultMessage='Your 7th best effort on this course.' />,
  },
  pr8: {
    title: <FormattedMessage id='achievements.pr8' defaultMessage='Personal Record 8' />,
    description: <FormattedMessage id='achivements.desc.pr8' defaultMessage='Your 8th best effort on this course.' />,
  },
  pr9: {
    title: <FormattedMessage id='achievements.pr9' defaultMessage='Personal Record 9' />,
    description: <FormattedMessage id='achivements.desc.pr9' defaultMessage='Your 9th best effort on this course.' />,
  },
  pr10: {
    title: <FormattedMessage id='achievements.pr10' defaultMessage='Personal Record 10' />,
    description: <FormattedMessage id='achivements.desc.pr10' defaultMessage='Your 10th best effort on this course.' />,
  },

  // King of the Mountain
  kom1: {
    title: <FormattedMessage id='achievements.kom1' defaultMessage='King of the Mountain' />,
    description: <FormattedMessage id='achivements.desc.kom1' defaultMessage='Mens 1st place overall' />,
  },
  kom2: {
    title: <FormattedMessage id='achievements.kom2' defaultMessage='King of the Mountain 2' />,
    description: <FormattedMessage id='achivements.desc.kom2' defaultMessage='2nd place overall.' />,
  },
  kom3: {
    title: <FormattedMessage id='achievements.kom3' defaultMessage='King of the Mountain 3' />,
    description: <FormattedMessage id='achivements.desc.kom3' defaultMessage='3rd place overall.' />,
  },
  kom4: {
    title: <FormattedMessage id='achievements.kom4' defaultMessage='King of the Mountain 4' />,
    description: <FormattedMessage id='achivements.desc.kom4' defaultMessage='4th place overall.' />,
  },
  kom5: {
    title: <FormattedMessage id='achievements.kom5' defaultMessage='King of the Mountain 5' />,
    description: <FormattedMessage id='achivements.desc.kom5' defaultMessage='5th place overall.' />,
  },
  kom6: {
    title: <FormattedMessage id='achievements.kom6' defaultMessage='King of the Mountain 6' />,
    description: <FormattedMessage id='achivements.desc.kom6' defaultMessage='6th place overall.' />,
  },
  kom7: {
    title: <FormattedMessage id='achievements.kom7' defaultMessage='King of the Mountain 7' />,
    description: <FormattedMessage id='achivements.desc.kom7' defaultMessage='7th place overall.' />,
  },
  kom8: {
    title: <FormattedMessage id='achievements.kom8' defaultMessage='King of the Mountain 8' />,
    description: <FormattedMessage id='achivements.desc.kom8' defaultMessage='8th place overall.' />,
  },
  kom9: {
    title: <FormattedMessage id='achievements.kom9' defaultMessage='King of the Mountain 9' />,
    description: <FormattedMessage id='achivements.desc.kom9' defaultMessage='9th place overall.' />,
  },
  kom10: {
    title: <FormattedMessage id='achievements.kom10' defaultMessage='King of the Mountain 10' />,
    description: <FormattedMessage id='achivements.desc.kom10' defaultMessage='10th place overall.' />,
  },

  // Queen of the Mountain
  qom1: {
    title: <FormattedMessage id='achievements.qom1' defaultMessage='Queen of the Mountain' />,
    description: <FormattedMessage id='achivements.desc.qom1' defaultMessage='Womens 1st place overall' />,
  },
  qom2: {
    title: <FormattedMessage id='achievements.qom2' defaultMessage='Queen of the Mountain 2' />,
    description: <FormattedMessage id='achivements.desc.qom2' defaultMessage='2nd place overall.' />,
  },
  qom3: {
    title: <FormattedMessage id='achievements.qom3' defaultMessage='Queen of the Mountain 3' />,
    description: <FormattedMessage id='achivements.desc.qom3' defaultMessage='3rd place overall.' />,
  },
  qom4: {
    title: <FormattedMessage id='achievements.qom4' defaultMessage='Queen of the Mountain 4' />,
    description: <FormattedMessage id='achivements.desc.qom4' defaultMessage='4th place overall.' />,
  },
  qom5: {
    title: <FormattedMessage id='achievements.qom5' defaultMessage='Queen of the Mountain 5' />,
    description: <FormattedMessage id='achivements.desc.qom5' defaultMessage='5th place overall.' />,
  },
  qom6: {
    title: <FormattedMessage id='achievements.qom6' defaultMessage='Queen of the Mountain 6' />,
    description: <FormattedMessage id='achivements.desc.qom6' defaultMessage='6th place overall.' />,
  },
  qom7: {
    title: <FormattedMessage id='achievements.qom7' defaultMessage='Queen of the Mountain 7' />,
    description: <FormattedMessage id='achivements.desc.qom7' defaultMessage='7th place overall.' />,
  },
  qom8: {
    title: <FormattedMessage id='achievements.qom8' defaultMessage='Queen of the Mountain 8' />,
    description: <FormattedMessage id='achivements.desc.qom8' defaultMessage='8th place overall.' />,
  },
  qom9: {
    title: <FormattedMessage id='achievements.qom9' defaultMessage='Queen of the Mountain 9' />,
    description: <FormattedMessage id='achivements.desc.qom9' defaultMessage='9th place overall.' />,
  },
  qom10: {
    title: <FormattedMessage id='achievements.qom10' defaultMessage='Queen of the Mountain 10' />,
    description: <FormattedMessage id='achivements.desc.qom10' defaultMessage='10th place overall.' />,
  },

  // Sprint Queen
  sprintq1: {
    title: <FormattedMessage id='achievements.sq1' defaultMessage='Sprint Queen' />,
    description: <FormattedMessage id='achivements.desc.sq1' defaultMessage='The female who has accumulated the most points on any flat course (out and back, segment or loop).' />,
  },
  sprintq2: {
    title: <FormattedMessage id='achievements.sq2' defaultMessage='Sprint Queen 2' />,
    description: <FormattedMessage id='achivements.desc.sq2' defaultMessage='2nd most points on any official sprint course' />,
  },
  sprintq3: {
    title: <FormattedMessage id='achievements.sq3' defaultMessage='Sprint Queen 3' />,
    description: <FormattedMessage id='achivements.desc.sq3' defaultMessage='3rd most points on any official sprint course' />,
  },
  sprintq4: {
    title: <FormattedMessage id='achievements.sq4' defaultMessage='Sprint Queen 4' />,
    description: <FormattedMessage id='achivements.desc.sq4' defaultMessage='4th most points on any official sprint course' />,
  },
  sprintq5: {
    title: <FormattedMessage id='achievements.sq5' defaultMessage='Sprint Queen 5' />,
    description: <FormattedMessage id='achivements.desc.sq5' defaultMessage='5th most points on any official sprint course' />,
  },
  sprintq6: {
    title: <FormattedMessage id='achievements.sq6' defaultMessage='Sprint Queen 6' />,
    description: <FormattedMessage id='achivements.desc.sq6' defaultMessage='6th most points on any official sprint course' />,
  },
  sprintq7: {
    title: <FormattedMessage id='achievements.sq7' defaultMessage='Sprint Queen 7' />,
    description: <FormattedMessage id='achivements.desc.sq7' defaultMessage='7th most points on any official sprint course' />,
  },
  sprintq8: {
    title: <FormattedMessage id='achievements.sq8' defaultMessage='Sprint Queen 8' />,
    description: <FormattedMessage id='achivements.desc.sq8' defaultMessage='8th most points on any official sprint course' />,
  },
  sprintq9: {
    title: <FormattedMessage id='achievements.sq9' defaultMessage='Sprint Queen 9' />,
    description: <FormattedMessage id='achivements.desc.sq9' defaultMessage='9th most points on any official sprint course' />,
  },
  sprintq10: {
    title: <FormattedMessage id='achievements.sq10' defaultMessage='Sprint Queen 10' />,
    description: <FormattedMessage id='achivements.desc.sq10' defaultMessage='10th most points on any official sprint course' />,
  },

  // Sprint King
  sprintk1: {
    title: <FormattedMessage id='achievements.sk1' defaultMessage='Sprint King' />,
    description: <FormattedMessage id='achivements.desc.sk1' defaultMessage='The male who has accumulated the most points on any flat course (out and back, segment or loop).' />,
  },
  sprintk2: {
    title: <FormattedMessage id='achievements.sk2' defaultMessage='Sprint King 2' />,
    description: <FormattedMessage id='achivements.desc.sk2' defaultMessage='2nd most points on any official sprint course' />,
  },
  sprintk3: {
    title: <FormattedMessage id='achievements.sk3' defaultMessage='Sprint King 3' />,
    description: <FormattedMessage id='achivements.desc.sk3' defaultMessage='3rd most points on any official sprint course' />,
  },
  sprintk4: {
    title: <FormattedMessage id='achievements.sk4' defaultMessage='Sprint King 4' />,
    description: <FormattedMessage id='achivements.desc.sk4' defaultMessage='4th most points on any official sprint course' />,
  },
  sprintk5: {
    title: <FormattedMessage id='achievements.sk5' defaultMessage='Sprint King 5' />,
    description: <FormattedMessage id='achivements.desc.sk5' defaultMessage='5th most points on any official sprint course' />,
  },
  sprintk6: {
    title: <FormattedMessage id='achievements.sk6' defaultMessage='Sprint King 6' />,
    description: <FormattedMessage id='achivements.desc.sk6' defaultMessage='6th most points on any official sprint course' />,
  },
  sprintk7: {
    title: <FormattedMessage id='achievements.sk7' defaultMessage='Sprint King 7' />,
    description: <FormattedMessage id='achivements.desc.sk7' defaultMessage='7th most points on any official sprint course' />,
  },
  sprintk8: {
    title: <FormattedMessage id='achievements.sk8' defaultMessage='Sprint King 8' />,
    description: <FormattedMessage id='achivements.desc.sk8' defaultMessage='8th most points on any official sprint course' />,
  },
  sprintk9: {
    title: <FormattedMessage id='achievements.sk9' defaultMessage='Sprint King 9' />,
    description: <FormattedMessage id='achivements.desc.sk9' defaultMessage='9th most points on any official sprint course' />,
  },
  sprintk10: {
    title: <FormattedMessage id='achievements.sk10' defaultMessage='Sprint King 10' />,
    description: <FormattedMessage id='achivements.desc.sk10' defaultMessage='10th most points on any official sprint course' />,
  },
}



// WEBPACK FOOTER //
// ./src/components/routes/myRoutes/constants/messages.jsx